import React from 'react';
import { DemeterNewsArticleModel, FundamentalMovement } from '../../../../Generated/Raven-Demeter';
import ColumnHeader from './ColumnHeader';
import ImpactBars from './ImpactBars';
import NewsCard from './NewsCard';
import styles from './NewsComponents.module.scss';
import { ArticleWithRating } from './NewsDefinitions';

interface INewsColumnProps {
    title: string;
    pairs: ArticleWithRating[];
    getMovement: (pair: ArticleWithRating) => FundamentalMovement | undefined;
    confidenceField: 'supply' | 'demand' | 'sentiment';
    onSelectArticle: (article: DemeterNewsArticleModel) => void;
}

const NewsColumn: React.FC<INewsColumnProps> = (props) => (
    <div className={styles.column}>
        <ColumnHeader title={props.title} pairs={props.pairs} getMovement={props.getMovement} confidenceField={props.confidenceField} />
        <ImpactBars pairs={props.pairs} />
        <div className={styles.column_body}>
            {props.pairs.length === 0 && <div className={styles.column_empty}>—</div>}
            {props.pairs.map((pair) => (
                <NewsCard
                    key={`${pair.article.demeterNewsArticleGuid}-${pair.rating.demeterNewsArticleRatingGuid}`}
                    title={pair.article.articleName ?? pair.article.demeterNewsArticleGuid}
                    date={pair.article.articleDate}
                    summary={pair.rating.summary}
                    geography={pair.rating.geography}
                    commodity={String(pair.rating.commodity ?? '')}
                    onClick={() => props.onSelectArticle(pair.article)}
                />
            ))}
        </div>
    </div>
);

export default NewsColumn;
